/* vp-lander.js -- buy box, countdown and sticky bar for sections/vp-lander.liquid
   The buy box is the claude-1 pattern: one row per purchasable variant carrying
   its own price and servings, a segmented quantity control, a tab pair for
   purchase type, and the plan card with its own price, frequency pills, Loop
   perks and gift row. Data comes from the #vp-lander-data island, so the rows
   follow real stock and real selling plans rather than a hardcoded list. */
(function(){
  var raw = document.getElementById("vp-lander-data");
  if(!raw) return;
  var DATA; try { DATA = JSON.parse(raw.textContent); } catch(e){ return; }
  if(!DATA.variants || !DATA.variants.length) return;

  var el = function(id){ return document.getElementById(id); };
  function money(n){ return "$" + n.toFixed(2); }

  /* Taste notes are editorial copy rather than product data, so they live here
     keyed by flavour and simply fall away for any flavour not listed. */
  var TASTE = {
    "Brown Sugar Oatmeal":"warm oats, brown sugar, a little cinnamon.",
    "Natural Vanilla":"clean vanilla bean, mixes with anything.",
    "Dole Whip® Pineapple":"tart tropical pineapple, soft-serve finish.",
    "Dole Whip® Strawberry":"bright ripe strawberry, soft-serve sweet.",
    "IHOP® Double Blueberry Pancakes":"blueberry compote over buttered pancakes.",
    "IHOP® Pancakes & Syrup":"buttermilk pancakes under warm syrup.",
    "IHOP® Cinn-A-Stack® Pancakes":"cinnamon roll swirl, brown sugar glaze.",
    "Chocolate Brownie Batter":"dark cocoa, fudgy, not too sweet.",
    "Frozen Hot Chocolate":"cocoa and cream, like a frozen hot chocolate."
  };

  /* Loop groups are hidden by id or exact name, same setting the PDP uses. */
  var HIDE = {};
  (DATA.hidePlanGroups || "").split(",").forEach(function(k){
    k = k.trim(); if(k) HIDE[k] = true;
  });
  function planAllowed(p){
    return !(HIDE[p.group] || HIDE[(DATA.planGroups || {})[p.group]]);
  }
  function planDays(p){
    var m = /(\d+)\s*days?/i.exec(p.name || "");
    return m ? parseInt(m[1], 10) : null;
  }

  var F = DATA.variants.map(function(v){
    return { n: v.flavor, size: v.size, v: v, preorder: !!v.preorder,
             t: TASTE[v.flavor] || "",
             plans: (v.plans || []).filter(planAllowed) };
  });

  /* qty_tiers, e.g. "1:0, 2:5" */
  var TIERS = (DATA.qtyTiers || "1:0").split(",").map(function(pair){
    var b = pair.split(":");
    return { q: parseInt(b[0], 10) || 0, pct: parseFloat(b[1]) || 0 };
  }).filter(function(t){ return t.q > 0; });
  if(!TIERS.length) TIERS = [{q:1, pct:0}];
  function tierPct(q){
    var pct = 0;
    TIERS.forEach(function(t){ if(q >= t.q && t.pct > pct) pct = t.pct; });
    return pct;
  }

  var state = { i:0, qty:1, mode:"sub", planId:null };
  var chipHost = el("vlChips"), tierHost = el("vlTiers"), root = el("offer");
  if(!chipHost || !tierHost) return;

  /* ---- flavour rows ---- */
  chipHost.className = "vp-chips";
  F.forEach(function(f, i){
    var b = document.createElement("button");
    b.type = "button";
    b.className = "vp-chip" + (f.preorder ? " has-tag" : "");
    b.setAttribute("aria-pressed", i === 0);
    b.innerHTML =
      '<span class="bag"><img src="' + f.v.img + '&width=120" alt="" loading="lazy"></span>' +
      '<span><span class="nm">' + f.n + '</span>' +
      '<span class="pr">' + money(f.v.price) + " · " + f.size + " srv</span>" +
      (f.t ? '<span class="ct">' + f.t + "</span>" : "") + "</span>" +
      (f.preorder ? '<span class="vp-tags"><span class="po-tag">pre-order</span></span>' : "");
    b.addEventListener("click", function(){ setFlavor(i); });
    chipHost.appendChild(b);
  });
  var chips = chipHost.querySelectorAll(".vp-chip");

  function setFlavor(i){
    state.i = i;
    Array.prototype.forEach.call(chips, function(c, ci){
      c.setAttribute("aria-pressed", ci === i);
    });
    var t = el("vlTaste"); if(t) t.textContent = F[i].t || "";
    paintFreq(); render();
  }

  /* ---- frequency pills, from the selected bag's own Loop plans ---- */
  function paintFreq(){
    var f = F[state.i], box = el("vlFreq"), plans = f.plans;
    if(!plans.length || state.mode !== "sub"){
      box.innerHTML = ""; box.hidden = true; state.planId = null; return;
    }
    box.hidden = false;
    var srv = parseInt(f.size, 10);
    if(!plans.some(function(p){ return p.id === state.planId; })){
      /* preselect the interval nearest the serving count, as the PDP does */
      state.planId = plans.reduce(function(best, p){
        var d = planDays(p), bd = planDays(best);
        return (d !== null && bd !== null && Math.abs(d - srv) < Math.abs(bd - srv)) ? p : best;
      }, plans[0]).id;
    }
    box.innerHTML = plans.map(function(p){
      var d = planDays(p);
      return '<button type="button" data-id="' + p.id + '" aria-pressed="' +
        (p.id === state.planId) + '">' + (d ? "every " + d + " days" : p.name) + "</button>";
    }).join("");
    Array.prototype.forEach.call(box.children, function(b){
      b.addEventListener("click", function(){
        state.planId = parseInt(b.dataset.id, 10); paintFreq(); render();
      });
    });
  }
  function currentPlan(){
    var plans = F[state.i].plans;
    for(var i = 0; i < plans.length; i++) if(plans[i].id === state.planId) return plans[i];
    return null;
  }

  /* ---- segmented quantity control ---- */
  function paintTiers(){
    tierHost.innerHTML = TIERS.map(function(t){
      return '<button type="button" role="radio" data-q="' + t.q + '" aria-checked="' +
        (t.q === state.qty) + '"><b>' + t.q + "</b>" +
        (t.pct > 0 ? "<i>save " + t.pct + "%</i>" : "") + "</button>";
    }).join("");
    Array.prototype.forEach.call(tierHost.children, function(b){
      b.addEventListener("click", function(){
        state.qty = parseInt(b.dataset.q, 10); paintTiers(); render();
      });
    });
  }

  function render(){
    var f = F[state.i], list = f.v.price, plan = currentPlan();
    var sub = state.mode === "sub" && plan;
    var unit = sub ? plan.price : list;
    /* Shopify floors the discount per unit to whole cents, then multiplies --
       mirroring it is what makes 2 bags read $60.80 rather than $60.78. */
    var pctOff = tierPct(state.qty);
    var unitCents = Math.round(unit * 100);
    var total = (unitCents - Math.floor(unitCents * pctOff / 100)) * state.qty / 100;
    var listTotal = list * state.qty;

    el("vlPrice").textContent = money(total);
    el("vlWas").textContent = money(listTotal);
    el("vlWas").style.display = total < listTotal - 0.005 ? "" : "none";
    var pct = Math.round((1 - total / listTotal) * 100);
    el("vlSave").textContent = "save " + pct + "%";
    el("vlSave").style.display = pct > 0 ? "" : "none";

    var note = el("vlTierNote");
    if(note){
      var txt = (DATA.tierNote || "").trim();
      note.hidden = !(pctOff > 0 && txt);
      note.textContent = txt;
    }

    el("vlBest").style.display = sub ? "" : "none";
    el("vlPre").hidden = !f.preorder;
    if(f.preorder) el("vlPre").innerHTML =
      "<b>Pre-order · " + f.size + "-serving bag · ships in about 60 days.</b>";

    /* Loop's own perk strings for the chosen plan, so they cannot drift from
       what merchandising actually promises. */
    var perks = [];
    if(sub && plan.desc){
      var tmp = document.createElement("div");
      tmp.innerHTML = plan.desc;
      perks = Array.prototype.map.call(tmp.querySelectorAll("span"), function(s){
        return s.textContent.trim();
      }).filter(Boolean);
    }
    if(!perks.length){
      perks = sub ? ["Free shipping when you subscribe", "Pause or cancel anytime"]
                  : ["Free shipping over $100", "30-day returns"];
    }
    el("vlPerks").innerHTML = perks.map(function(t){ return "<li>" + t + "</li>"; }).join("");

    var gift = el("vlGift"), g = DATA.gift;
    gift.textContent = "";
    gift.hidden = !(sub && g && g.head);
    if(sub && g && g.head){
      if(g.img){
        var gi = document.createElement("img");
        gi.src = g.img; gi.alt = g.product || "Free gift";
        gi.width = 54; gi.height = 54; gi.loading = "lazy";
        gift.appendChild(gi);
      }
      var gt = document.createElement("span");
      var gh = document.createElement("b"); gh.textContent = g.head; gt.appendChild(gh);
      if(g.variant){
        var gv = document.createElement("i"); gv.textContent = g.variant; gt.appendChild(gv);
      }
      gift.appendChild(gt);
    }
    el("vlAtcLabel").textContent = f.preorder ? "pre-order" : "add to cart";
  }

  /* ---- add to cart ------------------------------------------------------
     Posts an items array to /cart/add.js and hands the rendered sections to
     <cart-drawer>, the same path product-form.js takes -- that re-render is
     what remounts Rebuy. A full form POST would reload to /cart and skip it. */
  function cartDrawer(){ return document.querySelector("cart-drawer"); }
  function sectionIds(){
    var d = cartDrawer();
    return (d && typeof d.getSectionsToRender === "function")
      ? d.getSectionsToRender().map(function(x){ return x.id; }).join(",") : null;
  }
  el("vlAtc").addEventListener("click", function(){
    var btn = el("vlAtc"), errBox = el("vlErr");
    var f = F[state.i], plan = currentPlan(), sub = state.mode === "sub" && plan;
    btn.disabled = true;
    if(errBox) errBox.hidden = true;

    var line = { id: f.v.id, quantity: state.qty };
    if(sub) line.selling_plan = plan.id;
    /* the line-item property snippets/buy-buttons.liquid posts for a pre-order,
       without which the checkout acknowledgement never fires */
    if(f.preorder) line.properties = { preorder: "true" };

    var body = { items: [line] };
    var ids = sectionIds();
    if(ids){ body.sections = ids; body.sections_url = window.location.pathname; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(j){ return { ok: r.ok, json: j }; });
    }).then(function(res){
      if(!res.ok) throw new Error((res.json && res.json.description) || "Could not add to cart");
      var d = cartDrawer();
      if(d && res.json.sections && typeof d.renderContents === "function"){
        d.renderContents(res.json);
      } else {
        window.location.href = "/cart";
      }
    }).catch(function(e){
      if(errBox){ errBox.hidden = false; errBox.textContent = e.message; }
    }).then(function(){ btn.disabled = false; });
  });

  Array.prototype.forEach.call(root.querySelectorAll(".vp-tab"), function(t){
    t.addEventListener("click", function(){
      state.mode = t.dataset.mode;
      Array.prototype.forEach.call(root.querySelectorAll(".vp-tab"), function(x){
        x.setAttribute("aria-selected", x === t);
      });
      paintFreq(); render();
    });
  });

  paintTiers(); setFlavor(0);
})();


/* ---- promo bar + offer hero countdown ---- */
(function(){
  /* Deadline comes from the section setting via the island, so a merchant
     can move or clear it without a code change. Blank hides both clocks. */
  var host = document.getElementById("vp-lander-data");
  var PROMO_ENDS = null;
  try { PROMO_ENDS = JSON.parse(host.textContent).promoEnds || null; } catch(e){}

  /* One driver, two faces: the promo bar and the offer hero read the same
     constant, so they cannot advertise different deadlines. */
  var FACES = [
    {box:"pbarClock", d:"cdDay", h:"cdHr", m:"cdMin", s:"cdSec",
     dayWrap:"cdDayWrap", sep:"cdSep1"},
    {box:"ohClock",  d:"ohDay", h:"ohHr", m:"ohMin", s:"ohSec",
     dayWrap:"ohDayWrap", sep:"ohSep"}
  ].map(function(f){
    var o={}; for(var k in f) o[k]=document.getElementById(f[k]); return o;
  }).filter(function(f){ return f.box; });

  if(!FACES.length || !PROMO_ENDS) return;
  var end = new Date(PROMO_ENDS).getTime();
  if(isNaN(end)) return;
  function pad(n){ return n < 10 ? "0" + n : String(n); }

  function tick(){
    var left = end - Date.now();
    if(left <= 0){
      FACES.forEach(function(f){ f.box.hidden = true; });
      clearInterval(t); return;
    }
    var sec = Math.floor(left / 1000), days = Math.floor(sec / 86400);
    FACES.forEach(function(f){
      f.d.textContent = pad(days);
      f.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      f.m.textContent = pad(Math.floor(sec % 3600 / 60));
      f.s.textContent = pad(sec % 60);
      /* drop the days column once it is meaningless */
      if(f.dayWrap) f.dayWrap.hidden = days === 0;
      if(f.sep)     f.sep.hidden     = days === 0;
      f.box.hidden = false;
    });
  }
  tick();
  var t = setInterval(tick, 1000);
})();

/* ---- sticky CTA ---- */
(function(){
  var bar = document.getElementById("stickyCta");
  if(!bar) return;
  var closeBlock = document.getElementById("offer"), closeVisible = false;

  /* While the real CTA block is on screen the bar stands down -- two identical
     calls to action competing is worse than one. */
  if(window.IntersectionObserver && closeBlock){
    new IntersectionObserver(function(e){
      closeVisible = e[0].isIntersecting; update();
    }, {threshold: 0}).observe(closeBlock);
  }
  function update(){
    var past = window.scrollY > window.innerHeight * 0.6;
    var on = past && !closeVisible;
    bar.classList.toggle("on", on);
    bar.setAttribute("aria-hidden", on ? "false" : "true");
  }
  addEventListener("scroll", update, {passive:true});
  addEventListener("resize", update);
  update();
})();
